<!--
 * @Author: cmchiu
 * @Date: 2023-01-03 17:50:02
 * @LastEditTime: 2023-02-03 17:09:47
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\components\MyCourse\MyCourse.vue
 * 
-->
<template>
    <div class="my-course">
        <div class="row">
            <div class="col-lg-9 d-lg-block d-md-none d-sm-none d-none">
                <div class="row LM_text">
                    <div class="col-lg-2 LM01">
                        <img src="assets/images/learningmarket/LM01.png" alt="" />
                    </div>
                    <div class="col-lg-10">
                        <span>
                            學習市集是一個免費課程的訊息中心。您在線上填寫資料，完成預約後，就可以按時間地點去上課了!
                            開放對象：推廣教育部正規學制學員及教師(含進學、二技、二專及碩專班)
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-12">
                <div class="row LM_my">
                    <div class="col-lg-4 col-md-6 col-sm-6 col-6 LM02">
                        <img src="assets/images/learningmarket/LM02.png" alt="" />
                    </div>
                    <div class="col-lg-8 col-md-6 col-sm-6 col-6 LM_mycollapse">
                        <a
                            :class="showCollapseClass ? 'collapsed' : ''"
                            data-bs-toggle="collapse"
                            role="button"
                            :aria-expanded="showCollapseClass"
                            aria-controls="collapseClass"
                            @click="showCollapseClass = !showCollapseClass"
                        >
                            我的課程&thinsp;<i
                                class="fa-solid fa-circle-chevron-right chevron_right"
                                v-show="!showCollapseClass"
                            ></i
                            ><i class="fa-solid fa-circle-chevron-down chevron_down" v-show="showCollapseClass"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- 我的課程 展開 -->
        <div class="collapse myclass_collapse" :class="showCollapseClass ? 'show' : ''" id="collapseClass">
            <div class="card-body myclass_body">
                <div class="myclass_back d-lg-none d-md-none d-sm-none d-block">
                    <a
                        data-bs-toggle="collapse"
                        href="#collapseClass"
                        role="button"
                        aria-expanded="false"
                        aria-controls="collapseClass"
                        @click="showCollapseClass = !showCollapseClass"
                        >返回</a
                    >
                </div>
                <ul class="nav nav-fill mb-3 myclass_nav" v-if="user.isLogin">
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            id="pills-comingsoon-tab"
                            data-bs-toggle="-pill"
                            data-bs-target="#pills-comingsoon"
                            role="tab2"
                            aria-controls="pills-comingsoon"
                            :aria-selected="currentTab === 'pills-comingsoon'"
                            :class="currentTab === 'pills-comingsoon' ? 'active' : ''"
                            @click="toggleTabe('pills-comingsoon')"
                            >即將上課</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            id="pills-done-tab"
                            data-bs-toggle="-pill"
                            data-bs-target="#pills-done"
                            type="button"
                            role="tab2"
                            aria-controls="pills-done"
                            :aria-selected="currentTab === 'pills-done'"
                            :class="currentTab === 'pills-done' ? 'active' : ''"
                            @click="toggleTabe('pills-done')"
                            >已完成</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            id="pills-others-tab"
                            data-bs-toggle="-pill"
                            data-bs-target="#pills-others"
                            type="button"
                            role="tab2"
                            aria-controls="pills-others"
                            :aria-selected="currentTab === 'pills-others'"
                            :class="currentTab === 'pills-others' ? 'active' : ''"
                            @click="toggleTabe('pills-others')"
                            >其他</a
                        >
                    </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <!-- 我的預約課程清單 -->
                    <div
                        ref="pills-comingsoon"
                        class="tab-pane fade"
                        id="pills-comingsoon"
                        role="tabpanel"
                        aria-labelledby="pills-comingsoon-tab"
                        :class="currentTab === 'pills-comingsoon' ? 'show active' : ''"
                    >
                        <div class="tab_class_null" v-if="!user.isLogin">
                            <div class="login-first">
                                <img src="assets/images/computer.png" alt="" />
                                <p>請先登入系統</p>
                            </div>
                        </div>
                        <div
                            class="tab_class"
                            :style="myCourseLs.data.length >= 1 ? 'margin-top: 16px;' : ''"
                            v-for="row in myCourseLs.data"
                            :key="row.LMIT_ID"
                            v-else-if="myCourseLs.data.length > 0"
                        >
                            <div class="tab_class_info">
                                <div class="" style="display: flex; justify-content: space-between">
                                    <div class="">
                                        <p
                                            :class="
                                                row.LMAT_Class === '1001'
                                                    ? 'card_language' // 語文學習
                                                    : row.LMAT_Class === '1002'
                                                    ? 'card_tech' // 資訊科技
                                                    : row.LMAT_Class === '1003'
                                                    ? 'card_method' // 學習方法
                                                    : row.LMAT_Class === '1004'
                                                    ? 'card_basic' // 基礎科目輔導課
                                                    : row.LMAT_Class === '1005'
                                                    ? 'card_heart' // 心靈成長
                                                    : row.LMAT_Class === '1006'
                                                    ? 'card_paper' // 論文達人
                                                    : row.LMAT_Class === '1007'
                                                    ? 'card_career' // 職涯活動
                                                    : row.LMAT_Class === '1010'
                                                    ? 'card_workshop' // 校園活動(講座)
                                                    : row.LMAT_Class === '1011'
                                                    ? 'card_student' // 學生講師
                                                    : row.LMAT_Class === '1012'
                                                    ? 'card_meeting' // 教師請益時間
                                                    : ''
                                            "
                                        >
                                            {{ row.LMAT_ClassName }}
                                        </p>
                                    </div>

                                    <div class="tab_class_success">預約<br />成功</div>
                                </div>

                                <p class="card-text card_class">{{ row.LMIT_Name_1000 }}</p>

                                <div class="card-text card_teacher">{{ row.LMIT_Lecturer }}</div>
                                <div class="" style="display: flex">
                                    <div class="card-text card_room">{{ row.LMIT_Place }}</div>
                                    <div class="tab_border">
                                        <div class="card-text card_year">{{ row.LMIT_STime.substr(0, 4) }}</div>
                                        <div class="card-text">
                                            <span class="card_date">
                                                {{ row.LMIT_STime.substr(5, 5).replace('-', '/') }}
                                            </span>
                                            <span class="card_time">
                                                {{ row.LMIT_STime.substr(11, 5) }}
                                                <span class="card_time_icon">
                                                    <img src="assets/images/learningmarket/time.png" alt="time" />
                                                </span>
                                                {{ row.LMIT_ETime.substr(11, 5) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_class_btn">
                                <div class="tab_class_cancel">
                                    <el-link
                                        class="booking-cancel"
                                        :underline="false"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal3"
                                        @click="modalData = row"
                                        v-if="new Date(row.LMIT_STime.substr(0, 10)) - new Date() > 0"
                                    >
                                        我要取消
                                    </el-link>
                                    <el-tooltip content="當日不可取消預約" effect="dark" placement="right-end" v-else>
                                        <span class="booking-cancel" style="cursor: not-allowed"> 我要取消 </span>
                                    </el-tooltip>
                                </div>
                                <div class="tab_class_more">
                                    <router-link :to="`/coursebook?id=${row.LMIT_ID}&act=view`"> 瞭解詳情 </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="tab_class_null" v-else>
                            <img src="assets/images/learningmarket/myclassnull.png" alt="" />
                            <p>目前暫無相關課程</p>
                        </div>

                        <div class="go-next" v-if="user.isLogin && myCourseLs.data.length > 0">
                            <el-button
                                class="btnGoNext"
                                @click="nextPages({ list: myCourseLs, fn: getMyCourse })"
                                v-if="
                                    myCourseLs.pages.pageCurrent * myCourseLs.pages.pageSize + 1 <=
                                    myCourseLs.pages.totalResult
                                "
                            >
                                {{ `點擊查看下${myCourseLs.pages.pageSize}堂課程` }}
                            </el-button>
                            <el-button class="btnGoNext is-disabled" disabled v-else> 已經沒有更多的課程了 </el-button>
                        </div>
                    </div>
                    <!-- 已上過的課程清單 -->
                    <div
                        ref="pills-done"
                        class="tab-pane fade"
                        id="pills-done"
                        role="tabpanel"
                        aria-labelledby="pills-done-tab"
                        :class="currentTab === 'pills-done' ? 'show active' : ''"
                    >
                        <div class="tab_class_null" v-if="!user.isLogin">
                            <p style="color: #298081">請先登入系統</p>
                        </div>
                        <div
                            class="tab_class"
                            :style="myCoursePastLs.data.length >= 1 ? 'margin-top: 16px;' : ''"
                            v-for="row in myCoursePastLs.data"
                            :key="row.LMIT_ID"
                            v-else-if="myCoursePastLs.data.length > 0"
                        >
                            <div class="tab_class_info">
                                <div class="" style="display: flex; justify-content: space-between">
                                    <div class="">
                                        <p
                                            :class="
                                                row.LMAT_Class === '1001'
                                                    ? 'card_language' // 語文學習
                                                    : row.LMAT_Class === '1002'
                                                    ? 'card_tech' // 資訊科技
                                                    : row.LMAT_Class === '1003'
                                                    ? 'card_method' // 學習方法
                                                    : row.LMAT_Class === '1004'
                                                    ? 'card_basic' // 基礎科目輔導課
                                                    : row.LMAT_Class === '1005'
                                                    ? 'card_heart' // 心靈成長
                                                    : row.LMAT_Class === '1006'
                                                    ? 'card_paper' // 論文達人
                                                    : row.LMAT_Class === '1007'
                                                    ? 'card_career' // 職涯活動
                                                    : row.LMAT_Class === '1010'
                                                    ? 'card_workshop' // 校園活動(講座)
                                                    : row.LMAT_Class === '1011'
                                                    ? 'card_student' // 學生講師
                                                    : row.LMAT_Class === '1012'
                                                    ? 'card_meeting' // 教師請益時間
                                                    : ''
                                            "
                                        >
                                            {{ row.LMAT_ClassName }}
                                        </p>
                                    </div>

                                    <div class="tab_class_done">已完成</div>
                                </div>

                                <p class="card-text card_class">{{ row.LMIT_Name_1000 }}</p>

                                <div class="card-text card_teacher">{{ row.LMIT_Lecturer }}</div>
                                <div class="" style="display: flex">
                                    <div class="card-text card_room">{{ row.LMIT_Place }}</div>
                                    <div class="tab_border">
                                        <div class="card-text card_year">{{ row.LMIT_STime.substr(0, 4) }}</div>
                                        <div class="card-text">
                                            <span class="card_date">
                                                {{ row.LMIT_STime.substr(5, 5).replace('-', '/') }}
                                            </span>
                                            <span class="card_time">
                                                {{ row.LMIT_STime.substr(11, 5) }}
                                                <span class="card_time_icon">
                                                    <img src="assets/images/learningmarket/time.png" alt="time" />
                                                </span>
                                                {{ row.LMIT_ETime.substr(11, 5) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab_class_old">
                                <router-link :to="`/coursebook?id=${row.LMIT_ID}&act=view`"> 回顧課程 </router-link>
                            </div>
                        </div>
                        <div class="tab_class_null" v-else>
                            <img src="assets/images/learningmarket/myclassnull.png" alt="" />
                            <p>目前暫無相關課程</p>
                        </div>

                        <div class="go-next" v-if="user.isLogin && myCoursePastLs.data.length > 0">
                            <el-button
                                class="btnGoNext"
                                @click="nextPages({ list: myCoursePastLs, fn: getMyCoursePast })"
                                v-if="
                                    myCoursePastLs.pages.pageCurrent * myCoursePastLs.pages.pageSize + 1 <=
                                    myCoursePastLs.pages.totalResult
                                "
                            >
                                {{ `點擊查看下${myCoursePastLs.pages.pageSize}堂課程` }}
                            </el-button>
                            <el-button class="btnGoNext is-disabled" disabled v-else> 已經沒有更多的課程了 </el-button>
                        </div>
                    </div>
                    <!-- 其他預約紀錄 -->
                    <div
                        ref="pills-others"
                        class="tab-pane fade"
                        id="pills-others"
                        role="tabpanel"
                        aria-labelledby="pills-others-tab"
                        :class="currentTab === 'pills-others' ? 'show active' : ''"
                    >
                        <div class="tab_class_null" v-if="!user.isLogin">
                            <p style="color: #298081">請先登入系統</p>
                        </div>
                        <div
                            class="tab_class"
                            :style="myCourseOtherLs.data.length >= 1 ? 'margin-top: 16px;' : ''"
                            v-for="row in myCourseOtherLs.data"
                            :key="row.LMIT_ID"
                            v-else-if="myCourseOtherLs.data.length > 0"
                        >
                            <div class="tab_class_info">
                                <div class="" style="display: flex; justify-content: space-between">
                                    <div class="">
                                        <p
                                            :class="
                                                row.LMAT_Class === '1001'
                                                    ? 'card_language' // 語文學習
                                                    : row.LMAT_Class === '1002'
                                                    ? 'card_tech' // 資訊科技
                                                    : row.LMAT_Class === '1003'
                                                    ? 'card_method' // 學習方法
                                                    : row.LMAT_Class === '1004'
                                                    ? 'card_basic' // 基礎科目輔導課
                                                    : row.LMAT_Class === '1005'
                                                    ? 'card_heart' // 心靈成長
                                                    : row.LMAT_Class === '1006'
                                                    ? 'card_paper' // 論文達人
                                                    : row.LMAT_Class === '1007'
                                                    ? 'card_career' // 職涯活動
                                                    : row.LMAT_Class === '1010'
                                                    ? 'card_workshop' // 校園活動(講座)
                                                    : row.LMAT_Class === '1011'
                                                    ? 'card_student' // 學生講師
                                                    : row.LMAT_Class === '1012'
                                                    ? 'card_meeting' // 教師請益時間
                                                    : ''
                                            "
                                        >
                                            {{ row.LMAT_ClassName }}
                                        </p>
                                    </div>

                                    <div
                                        class="tab_class_canceledorder"
                                        v-if="row.LMB_Status === '10' && !row.LMB_AbsentMark"
                                    >
                                        尚未<br />點名
                                    </div>
                                    <div
                                        class="tab_class_canceledorder"
                                        v-else-if="row.LMB_Status === '10' && row.LMB_AbsentMark === 'N'"
                                    >
                                        預約<br />缺席
                                    </div>
                                    <div class="tab_class_canceledorder" v-else-if="row.LMB_Status === '20'">
                                        取消<br />預約
                                    </div>
                                    <div class="tab_class_canceledorder" v-else-if="row.LMB_Status === '30'">
                                        退回<br />預約
                                    </div>
                                    <!-- <div class="tab_class_canceledorder" v-else>N/A</div> -->
                                </div>

                                <p class="card-text card_class">{{ row.LMIT_Name_1000 }}</p>

                                <div class="card-text card_teacher">{{ row.LMIT_Lecturer }}</div>
                                <div class="" style="display: flex">
                                    <div class="card-text card_room">{{ row.LMIT_Place }}</div>
                                    <div class="tab_border">
                                        <div class="card-text card_year">{{ row.LMIT_STime.substr(0, 4) }}</div>
                                        <div class="card-text">
                                            <span class="card_date">
                                                {{ row.LMIT_STime.substr(5, 5).replace('-', '/') }}
                                            </span>
                                            <span class="card_time">
                                                {{ row.LMIT_STime.substr(11, 5) }}
                                                <span class="card_time_icon">
                                                    <img src="assets/images/learningmarket/time.png" alt="time" />
                                                </span>
                                                {{ row.LMIT_ETime.substr(11, 5) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab_class_old">
                                <router-link :to="`/coursebook?id=${row.LMIT_ID}&act=view`"> 回顧課程 </router-link>
                            </div>
                        </div>
                        <div class="tab_class_null" v-else>
                            <img src="assets/images/learningmarket/myclassnull.png" alt="" />
                            <p>目前暫無相關課程</p>
                        </div>

                        <div class="go-next" v-if="user.isLogin && myCourseOtherLs.data.length > 0">
                            <el-button
                                class="btnGoNext"
                                @click="nextPages({ list: myCourseOtherLs, fn: getMyCourseOther })"
                                v-if="
                                    myCourseOtherLs.pages.pageCurrent * myCourseOtherLs.pages.pageSize + 1 <=
                                    myCourseOtherLs.pages.totalResult
                                "
                            >
                                {{ `點擊查看下${myCourseOtherLs.pages.pageSize}堂課程` }}
                            </el-button>
                            <el-button class="btnGoNext is-disabled" disabled v-else> 已經沒有更多的課程了 </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------- -->

        <!-- Modal:Cancel Booking -->
        <div
            class="modal fade"
            id="exampleModal3"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            v-loading.lock="configs.loading"
            element-loading-text="請稍候，目前正處理取消預約..."
            element-loading-background="rgba(255, 255, 255, 0.5)"
        >
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="survey_modal_header">
                        <div class="survey_img mb-2">
                            <img src="assets/images/learningmarket/null.png" alt="" />
                        </div>
                        <!-- <div>
                            <h5 class="modal-title survey_modal_title" id="exampleModalLabel">
                                是否確定取消預約『<span style="color: blue">???</span>』課程?
                            </h5>
                        </div> -->
                    </div>
                    <div class="modal-body survey_modal_body">
                        <p>
                            是否確定取消預約『
                            <span style="color: blue; font-weight: bold"> {{ modalData.LMIT_Name_1000 }} </span>
                            』課程?
                        </p>
                    </div>
                    <div class="survey_footer">
                        <button type="button" class="btn survey_btnclose" data-bs-dismiss="modal" ref="btnCancel">
                            取消
                        </button>
                        <button type="button" class="btn survey_btnsubmit" @click="handleCancelBook(modalData)">
                            送出
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------- -->
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getMyCourse, getMyCoursePast, getMyCourseOther, cancelBook } from '@/api/course'

export default {
    name: 'MyCourse',

    props: {
        isLogin: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            configs: {
                loading: false,
                defaultLs: {
                    data: [],
                    pages: {
                        totalResult: 0, // 總筆數
                        pageSize: 10, // 分頁大小
                        pageCurrent: 1, // 目前頁次
                    },
                },
            },
            user: {
                isLogin: this.$store.getters.isLogin,
                id: '',
                name: '',
                email: '',
                class: '',
            },
            myCourseLs: {
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 10, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
            myCoursePastLs: {
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 10, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
            myCourseOtherLs: {
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 10, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
            currentTab: 'pills-comingsoon',
            showCollapseClass: false,
            modalData: [],
        }
    },

    created: function () {},

    mounted: function () {
        /* const vm = this
        const timer = window.setInterval(() => {
            vm.$store.dispatch('user/checkLogin').then(isLogin => {
                vm.user.isLogin = isLogin
            })
        }, 1000)
        // 组件銷毀前, 清除定時器
        vm.$once('hook:beforeDestroy', () => {
            window.clearInterval(timer)
        }) */
    },

    watch: {
        '$store.getters.isLogin': function (newVal, oldVal) {
            if (!XEUtils.isEqual(newVal, oldVal)) this.user.isLogin = newVal
        },
        '$store.getters.userInfo': function (newVal, oldVal) {
            const vm = this
            vm.user = newVal
            if (!XEUtils.isEqual(newVal, oldVal) && vm.user.isLogin) {
                vm.getMyCourse(true)
                vm.getMyCoursePast(true)
                vm.getMyCourseOther(true)
            }
        },
        '$store.getters.reload': function (newVal, oldVal) {
            const vm = this
            if (!XEUtils.isEqual(newVal, oldVal)) {
                vm.getMyCourse(true)
                vm.getMyCoursePast(true)
                vm.getMyCourseOther(true)
            }
        },
    },

    methods: {
        async getMyCourse(reset) {
            const vm = this
            if (typeof reset === 'boolean' && reset) {
                vm.myCourseLs = XEUtils.clone(vm.configs.defaultLs, true)
            }
            let params = {
                Acpd_ID: vm.user.id,
                PageSize: vm.myCourseLs.pages.pageSize,
                PageCurrent: vm.myCourseLs.pages.pageCurrent,
            }
            await getMyCourse(params).then(res => {
                if (res.Code === 1) {
                    // vm.myCourseLs.data = res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        vm.myCourseLs.data.push(item)
                    })
                    vm.myCourseLs.pages.totalResult = res.TotalResult
                } else {
                    vm.myCourseLs.data = []
                    vm.myCourseLs.pages.totalResult = 0
                }
            })
        },

        async getMyCoursePast(reset) {
            const vm = this
            if (typeof reset === 'boolean' && reset) {
                vm.myCoursePastLs = XEUtils.clone(vm.configs.defaultLs, true)
            }
            let params = {
                Acpd_ID: vm.user.id,
                PageSize: vm.myCoursePastLs.pages.pageSize,
                PageCurrent: vm.myCoursePastLs.pages.pageCurrent,
            }
            await getMyCoursePast(params).then(res => {
                if (res.Code === 1) {
                    // vm.myCoursePastLs.data = res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        vm.myCoursePastLs.data.push(item)
                    })
                    vm.myCoursePastLs.pages.totalResult = res.TotalResult
                } else {
                    vm.myCoursePastLs.data = []
                    vm.myCoursePastLs.pages.totalResult = 0
                }
            })
        },

        async getMyCourseOther(reset) {
            const vm = this
            if (typeof reset === 'boolean' && reset) {
                vm.myCourseOtherLs = XEUtils.clone(vm.configs.defaultLs, true)
            }
            let params = {
                Acpd_ID: vm.user.id,
                PageSize: vm.myCourseOtherLs.pages.pageSize,
                PageCurrent: vm.myCourseOtherLs.pages.pageCurrent,
            }
            await getMyCourseOther(params).then(res => {
                if (res.Code === 1) {
                    // vm.myCourseOtherLs.data = res.Items
                    XEUtils.arrayEach(res.Items, item => {
                        vm.myCourseOtherLs.data.push(item)
                    })
                    vm.myCourseOtherLs.pages.totalResult = res.TotalResult
                } else {
                    vm.myCourseOtherLs.data = []
                    vm.myCourseOtherLs.pages.totalResult = 0
                }
            })
        },

        async cancelBook(acpdId, lmitId) {
            const vm = this
            vm.configs.loading = true
            let params = {
                Acpd_ID: acpdId,
                LMIT_ID: lmitId,
            }
            await cancelBook(params)
                .then(res => {
                    if (res.Code === 1) {
                        vm.$message({
                            type: 'success',
                            message: res.Msg,
                            dangerouslyUseHTMLString: true,
                        })
                    }
                })
                .catch(err => {
                    // handle error
                    console.log(err)
                })
                .then(() => {
                    vm.configs.loading = false
                    vm.$refs.btnCancel.click()
                })
        },

        handleCancelBook(row) {
            const vm = this
            if (new Date(row.LMIT_STime.substr(0, 10)) - new Date() > 0) {
                vm.cancelBook(row.acpd_id, row.LMIT_ID).then(() => {
                    vm.$store.dispatch('app/reloadComponents', !vm.$store.getters.reload)
                })
            } else {
                vm.$message({
                    message: '當日不可取消預約',
                    type: 'warning',
                })
            }
        },

        toggleTabe(tabName) {
            this.currentTab = tabName
        },

        nextPages({ list, fn }) {
            let page = list.pages
            if (page.pageCurrent * page.pageSize + 1 <= page.totalResult) {
                page.pageCurrent++
                fn()
            }
        },
    },
}
</script>

<style scoped lang="scss">
:deep .booking-cancel > span {
    color: #fff;
    font-size: 25px;
    font-weight: 700;
}
:deep .booking-cancel > span:hover {
    color: #fff;
    font-size: 25px;
    font-weight: 700;
}
.modal-body {
    color: #2d9698;
}
:deep .go-next {
    margin-top: 16px;
    text-align: center;

    .btnGoNext {
        width: 18rem;
        height: 38px;
        font-size: 20px;
        padding: 5px 50px;
        border-radius: 25px;
        background-color: #2d9698;
        color: #fff;
    }
    .btnGoNext:hover {
        width: 18rem;
        height: 38px;
        font-size: 20px;
        padding: 5px 50px;
        border-radius: 25px;
        background-color: #37b4b6;
        color: #fff;
    }
    .btnGoNext.is-disabled {
        width: 18rem;
        height: 38px;
        font-size: 20px;
        padding: 5px 50px;
        border-radius: 25px;
        background-color: #ccc;
        color: #fff;
    }
}
.login-first {
    margin-top: 25%;

    p {
        color: #298081;
        font-size: 1.2rem;
    }
}
</style>
